import { logout, isAuthenticated } from "./auth";

let idleTimer = null;
const IDLE_LIMIT = 60 * 60 * 1000; // 1 hour

const resetIdleTimer = () => {
  if (!isAuthenticated()) return;

  if (idleTimer) clearTimeout(idleTimer);

  idleTimer = setTimeout(() => {
    logout();
  }, IDLE_LIMIT);
};

export const setupIdleLogout = () => {
  const events = [
    "mousemove",
    "keydown",
    "click",
    "scroll",
    "touchstart"
  ];

  events.forEach(event =>
    window.addEventListener(event, resetIdleTimer)
  );

  resetIdleTimer(); // start timer immediately
};
